import {
  GridColDef,
  GridRowModel,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import { dayjsFormatTZ, dayjsTZ, initLanContent, isDate1 } from "helpers";
import capitalize from "lodash/capitalize";
import _get from "lodash/get";
import { i18n } from "translations";
import { checkMainLan } from "utils";

export const getRowsWithIndex = <T>(data?: T[]) => {
  if (!data) return [];
  return data.map((item, index) => ({
    id: index + 1,
    ...item,
    index: index + 1,
  }));
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getColumnsWithMultiLan = <T extends GridValidRowModel>(
  columns: (GridColDef<T> & {
    nestedField?: string;
    fieldType?: "number" | "date";
    mappingValue?: Record<string | number, string>;
    mappingValueRender?: Record<string | number, string>;
    multiLan?: boolean;
    headerNameLan?: [string, string];
  })[],
  config?: {
    showCellInvalid?: boolean;
    showFilter?: boolean;
    minWidth?: number;
  }
) => {
  const { showCellInvalid = false, showFilter = true, minWidth } = config || {};
  const noFilterConfig = {
    disableColumnMenu: true,
    resizable: false,
    sortable: false,
  };
  return columns?.map((item) => ({
    ...(!showFilter && noFilterConfig),
    ...(showCellInvalid && {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      cellClassName: ({ row }: any) =>
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ((row?.errorFields as any[]) || [])?.includes(item.field)
          ? "invalid-cell"
          : "",
    }),
    ...(item.fieldType === "number"
      ? {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          renderCell: ({ value }: any) =>
            Number(value)
              ? new Intl.NumberFormat("en-US").format(value as number)
              : 0,
          align: "right" as never,
        }
      : {}),
    ...(item.fieldType === "date"
      ? {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          renderCell: ({ value }: any) => {
            if (isDate1(String(value))) {
              return dayjsFormatTZ(value as string, "YYYY-MM-DD").format(
                "DD/MM/YYYY"
              );
            }
            return value ? dayjsTZ(value as string).format("DD/MM/YYYY") : "";
          },
        }
      : {}),
    ...(item.nestedField && {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return
      valueGetter: ({ row }: any) => _get(row, item.nestedField as never),
    }),
    ...(item.mappingValue && {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      valueGetter: ({ value }: any) => {
        return item.mappingValue?.[value as string] || "";
      },
    }),
    ...(item.mappingValueRender && {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      render: ({ value }: any) =>
        item.mappingValueRender?.[value as string] || "",
    }),
    ...(minWidth && {
      minWidth,
    }),
    ...item,
    ...(item.multiLan && {
      field: checkMainLan() ? `native${capitalize(item.field)}` : item.field,
    }),
    headerName: item?.headerNameLan
      ? initLanContent(item?.headerNameLan)
      : i18n.t(item?.headerName as string),
  }));
};

export function updateRowPosition(
  initialIndex: number,
  newIndex: number,
  rows: Array<GridRowModel>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any[] {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-explicit-any
  const rowsClone = [...rows]?.map((i: any) => ({
    ...i,
    isChanged: true,
  }));
  const row = rowsClone.splice(initialIndex, 1)[0];
  rowsClone.splice(newIndex, 0, { ...row, isNew: true, isChanged: true });
  return rowsClone;
}
